import { useEoState } from '~/src/hooks/useEoState'
import { LANGUAGE_STATE } from '~/src/stores/lang'
import { DateUtils, LanguageType } from '@eo-storefronts/eo-core'
import CookiesUtils from '~/src/utils/CookiesUtils'
import ApiConfigUtils from '~/src/utils/ApiConfigUtils'
import { useTranslations } from '~/src/hooks/useTranslations'
import { Constants } from '~/src/helpers/constants'
import { useEffect } from 'react'

const useSetLanguageState = () => {
  const { t } = useTranslations()
  const [ currentLanguage, setLanguageState ] = useEoState(LANGUAGE_STATE)

  const setAppLanguage = (lang: LanguageType | string) => {
    if (lang === '') {
      return
    }

    CookiesUtils.setCookie(CookiesUtils.LANG, lang, 365)
    ApiConfigUtils.setLanguage(lang as LanguageType)

    setLanguageState(lang)
  }

  useEffect(() => {
    if (!currentLanguage) {
      return
    }

    const dateFormatDefinitions = {
      calendar: {
        sameDay: `[${t('global.today')}] [${t('global.at')}] HH:mm`,
        nextDay: `[${t('global.tomorrow')}] [${t('global.at')}] HH:mm`,
        lastDay: `[${t('global.yesterday')}] [${t('global.at')}] HH:mm`,
        nextWeek: Constants.DEFAULT_MOMENT_CALENDAR_FORMAT,
        lastWeek: Constants.DEFAULT_MOMENT_CALENDAR_FORMAT,
        sameElse: Constants.DEFAULT_MOMENT_CALENDAR_FORMAT
      }
    }

    if (currentLanguage === 'no') {
      DateUtils.setLocale('nb', dateFormatDefinitions)
    } else {
      DateUtils.setLocale(currentLanguage, dateFormatDefinitions)
    }
  }, [ currentLanguage ])

  return {
    setAppLanguage
  }
}

export default useSetLanguageState
